import {useCallback, useEffect, useState} from 'react';
import {useUiState} from '../Components/Context/UserInterface/UserInterfaceContext';
import useSettings from './useSettings';
import {ViewMode} from '@taopix/taopix-core';
import {UserInterfaceActions} from '../Components/Context/UserInterface/UserInterfaceActionTypes';
import {useExperience} from '../Components/Experience/ExperienceProvider';

const useViewMode = (): [ViewMode, (viewMode: ViewMode) => void] => {
  const ui = useUiState();
  const settings = useSettings();
  const {experience} = useExperience();
  const [viewMode, setViewMode] = useState(ui?.state?.viewMode || ViewMode.None);
  const storedViewMode =
    sessionStorage.getItem(`${settings?.state?.tokens?.session}-viewMode`) || '';

  const viewMap = {
    ls: ViewMode.List,
    gv: ViewMode.Grid,
    spv: ViewMode.Single,
  };

  useEffect(() => {
    const viewModes = experience.EDITOR.workArea.editingViewModes;
    let validViewMode = storedViewMode;
    if (('' as ViewMode) !== validViewMode) {
      if (Object.prototype.hasOwnProperty.call(viewModes, validViewMode)) {
        if (!viewModes[validViewMode]) {
          validViewMode = viewMap[experience.EDITOR.workArea.defaultView];
        }
      }
    } else {
      validViewMode = viewMap[experience.EDITOR.workArea.defaultView] || ViewMode.None;
    }

    setViewMode(validViewMode as ViewMode);
  }, [settings.state, storedViewMode, experience]);

  const onSetViewMode = useCallback(
    (mode: ViewMode) => {
      ui.dispatch(UserInterfaceActions.setViewMode(mode));
      sessionStorage.setItem(`${settings.state.tokens.session}-viewMode`, mode);
      setViewMode(mode);
    },
    [settings.state]
  );

  return [viewMode, onSetViewMode];
};

export default useViewMode;
